/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function () {
    const targetElements = document.querySelectorAll('.sticky-text__heading.h2 em');
    targetElements.forEach((targetElement) => {
      if (targetElement.textContent.trim().toLowerCase() === 'pickleball') {
        const texts = ['pickleball', 'padel', 'tennis', 'golf'];
        let index = 0;
        let charIndex = 0;
        let currentText = texts[index];
        let isDeleting = false;
        let delay = 1000; // 1 second delay

        function type() {
          if (isDeleting) {
            targetElement.textContent = currentText.substring(0, charIndex - 1) || '\u00A0';
            charIndex--;
            if (charIndex === 0) {
              isDeleting = false;
              index = (index + 1) % texts.length;
              currentText = texts[index];
            }
          } else {
            targetElement.textContent = currentText.substring(0, charIndex + 1);
            charIndex++;
            if (charIndex === currentText.length) {
              isDeleting = true;
              setTimeout(type, delay); // Delay before starting to delete
              return;
            }
          }
          setTimeout(type, isDeleting ? 100 : 200); // Slower animation
        }

        type();
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
